import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../assets/img/logo.svg";
import logoEcourses from "../assets/img/logo epistum-ecourses.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";
import { HashLink } from "react-router-hash-link";
import { BrowserRouter as Router } from "react-router-dom";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar expand="xl" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={logoEcourses} alt="Logo" />
          </Navbar.Brand>
          <span className="navbar-text">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/showcase/epistum-cloud/?viewAsMember=true"
                target="_blank"
              >
                <img src={navIcon1} alt="linkedin" />
              </a>
              <a
                href="https://www.facebook.com/people/Epistum/100086978004302/"
                target="_blank"
              >
                <img src={navIcon2} alt="facebook" />
              </a>
              <a href="https://www.youtube.com/@epistumlms6103" target="_blank">
                <img src={navIcon3} alt="youtube" />
              </a>
              <a
                href="https://www.instagram.com/epistum_cloud/"
                target="_blank"
              >
                <img src={navIcon4} alt="instagram" />
              </a>
            </div>
          </span>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                className={
                  activeLink === "home" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="#levels"
                className={
                  activeLink === "levels" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("levels")}
              >
                Levels
              </Nav.Link>
              <Nav.Link
                href="#projects"
                className={
                  activeLink === "projects"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("projects")}
              >
                Projects
              </Nav.Link>
              <Nav.Link
                href="https://www.epistum.com "
                target="_blank"
                className={
                  activeLink === "web_site"
                    ? "active navbar-link"
                    : "navbar-link"
                }
              >
                Website
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
